import { useFeatureVariation } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES, FEATURE_VARIATIONS } from 'utils/experiment';
export const useAirportPriceExperiment = () => {
    const variation = useFeatureVariation(IMMEDIATE_FEATURES.AIRPORT_TOTAL_PRICE_TEST);
    const airportExperimentVariation = FEATURE_VARIATIONS[IMMEDIATE_FEATURES.AIRPORT_TOTAL_PRICE_TEST];
    const showSubtotal = variation === airportExperimentVariation.SHOW_SUBTOTAL;
    const defaultToTotalPrice = variation === airportExperimentVariation.TOTAL_PRICE_TOGGLE_ON;
    const hideTotalToggle = variation === airportExperimentVariation.SHOW_TOTAL_PRICE_NO_TOGGLE;
    return {
        showSubtotal,
        defaultToTotalPrice,
        hideTotalToggle,
    };
};
